import { Select, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import P4Regular from 'components/typography/P4Regular';
import { useFormInputs } from 'pages/revisions-module/template-editor/editors/form/input/FormInputsDataProvider';
import { IAutomationCreateChildDepartment } from 'pages/revisions-module/template-editor/editors/pipeline/types';
import { useMemo } from 'react';

export const CHILD_DEPARTMENT_FIELD_LABELS = {
  departmentName: 'Názov objektu',
  departmentNumber: 'Číslo objektu',
  streetAddress: 'Adresa',
  city: 'Mesto',
  zip: 'PSČ',
  country: 'Štát',
};

/** Maps revision-context string fields onto a child object's identity and address. */
export default function CreateChildDepartmentSubForm({
  form,
}: {
  form: UseFormReturnType<IAutomationCreateChildDepartment>;
}) {
  const { allInputs } = useFormInputs();
  const options = useMemo(
    () =>
      allInputs
        .filter(
          ({ context, spec }) =>
            context === 'revision' &&
            (spec.type === 'text' ||
              spec.type === 'textExpression' ||
              spec.type === 'select' ||
              (spec.type === 'constant' && (spec.constantType ?? 'text') === 'text'))
        )
        .map(({ spec }) => ({ value: spec.name, label: spec.label })),
    [allInputs]
  );

  return (
    <Stack spacing={12}>
      <P4Regular color="gray.6">
        Objekt sa vytvorí priamo pod objektom priradeným k revízii alebo formuláru, najviac raz pre tento proces. Na
        poslednej úrovni hierarchie sa vytvorenie preskočí. Výsledok sa zapíše do záznamov.
      </P4Regular>
      {Object.entries(CHILD_DEPARTMENT_FIELD_LABELS).map(([field, label]) => (
        <Select
          key={field}
          data={options}
          label={label}
          placeholder={field === 'departmentName' ? 'Vyberte pole' : 'Bez hodnoty'}
          required={field === 'departmentName'}
          clearable={field !== 'departmentName'}
          searchable
          size="sm"
          {...form.getInputProps(`fieldMappings.${field}`)}
        />
      ))}
    </Stack>
  );
}
